global.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = true;

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import NavBar from "./components/NavBar.vue";

//JsonViewer
import JsonViewer from 'vue3-json-viewer'
import 'vue3-json-viewer/dist/index.css'


//Bootstrap
import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";

//Entidad AWS
import Repository from "../src/repositories/Repository";
Repository.init(process.env.VUE_APP_BASE_API);
import "../styleguide.css";

//Iniciar app
const app = createApp(App);
app.component("NavBar", NavBar);
app.component('JsonViewer', JsonViewer);
app.use(router);
app.mount("#app");
